export function getCommonAuthenticatedHeaders(
  accessToken: string,
  mimeType = 'application/json',
) {
  return {
    'Content-Type': mimeType,
    Authorization: `Bearer ${accessToken}`,
  };
}
